import {Collection} from './Collection';
import {Product} from './Product';
import {Style} from './Style';

export class Model {
  public id: number;
  public name: string;
  public code: string;
  public productCount: string;
  public collection: Collection;
  public styles: Style[];
  public status: string;
  public products: Product[];
  public supplier?: any;
  public position: number;
  public parentPosition: number;
  public optionProducts?: any;
  public message?: string;
}
